<template>
  <div class="information">
    <div class="col1">
      <van-image class="avatarImg" :src="avatar"></van-image>
    </div>
    <div class="col2" @click="gotoPoints">
      <div class="row2">
        <span class="label">{{ $t.information.name }}</span>
        <span class="name">{{ homeData.CompanyName }}</span>
      </div>
      <div class="row2">
        <span class="label">{{ $t.information.customerNumber }}</span
        ><span class="txt">{{ homeData.CustomerNumber }}</span>
      </div>
      <div class="row2" v-if="homeData.CustomerPhone">
        <span class="label">{{ $t.information.phoneNumber }}</span
        ><span class="txt">{{ homeData.CustomerPhone }}</span>
      </div>
      <div class="row2" v-if="homeData.Email">
        <span class="label">{{ $t.information.email }}</span>
        <span class="txt">{{ homeData.Email }}</span>
      </div>
      <div class="row2">
        <span class="label">{{ $t.information.availablePoints }}</span>
        <span class="txt">{{ homeData.AvailablePoints }}</span>
      </div>
    </div>
    <div class="col3" @click="gotoEdit">
      <van-image class="iconImg" :src="edit"></van-image>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image } from "vant";
Vue.use(Image);
export default {
  name: "Information",
  props: {
    homeData: {
      type: Object,
    },
  },
  data() {
    return {
      avatar: require("@/assets/img/userManage/img_logo@2x.png"),
      qrCode: require("@/assets/img/home/qr-code.png"),
      phone: require("@/assets/img/home/phone.png"),
      email: require("@/assets/img/home/email.png"),
      edit: require("@/assets/img/home/edit.png"),
    };
  },
  methods: {
    gotoPoints() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "user/pointsList",
        name: "PointsList",
        query: [],
      });
    },
    gotoEdit() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "user/editInformation",
        name: "EditInformation",
        query: [
          {
            name: "IsNew",
            value: false,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
// 是设计图是三杯图
.information {
  background: #ffffff;
  margin: 5% 5% 2% 5%;
  padding: 5% 0;
  border-radius: 20px;
  color: #0e78a6;
  box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 50%);
}
.col1 {
  text-align: center;
  vertical-align: middle;
  display: inline-block;
  width: 30%;
  .avatarImg {
    width: 40%;
    height: 40%;
  }
}
.col2 {
  margin-top: 5px;
  vertical-align: middle;
  display: inline-block;
  width: 60%;
  font-size: 12px;
  .row2 {
    line-height: 20px;
    margin-bottom: 5px;
    overflow: hidden;
    .name {
      height: 18px;
      width: 70%;
      display: inline-block;
      margin-left: 10px;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      vertical-align: top;
      white-space: nowrap;
    }
    .label {
      height: 18px;
      display: inline-block;
      color: #999;
      vertical-align: middle;
    }
    .txt {
      height: 18px;
      width: 70%;
      display: inline-block;
      margin-left: 10px;
      color: #999;
      font-weight: normal;
      vertical-align: middle;
      white-space: nowrap;
    }
  }
  .iconImg {
    width: 18px;
    height: 18px;
    margin-right: 3px;
    margin-left: 3px;
    object-fit: contain;
    vertical-align: middle;
  }
}
.col3 {
  text-align: center;
  vertical-align: top;
  display: inline-block;
  width: 10%;
  .iconImg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 15px;
    vertical-align: middle;
  }
}
</style>
